import { PlayerStyleMetrics } from '../types';

export function generatePlayerStyle(metrics: PlayerStyleMetrics): string[] {
  const styles: string[] = [];

  // Speed
  if (metrics.averageTurnTime < 15) {
    styles.push('Relámpago');
  } else if (metrics.averageTurnTime > 60) {
    styles.push('Pensador');
  }

  // Word length
  if (metrics.longWordRate > 0.4) {
    styles.push('Vocabulario extenso');
  } else if (metrics.longWordRate < 0.1) {
    styles.push('Estratega de corto alcance');
  }

  // Multipliers
  if (metrics.premiumUsageRate > 0.5) {
    styles.push('Caza-multiplicadores');
  }

  // Bingos
  if (metrics.bingoRate > 0.1) {
    styles.push('Maestro del Atril Completo');
  }

  // Swaps/Passes
  if (metrics.swapRate > 0.2) {
    styles.push('Perfeccionista de atril');
  }

  if (metrics.passRate > 0.1) {
    styles.push('Cauteloso');
  }

  // Vowel/Consonant balance
  if (metrics.vowelConsonantBalance > 2 || metrics.vowelConsonantBalance < 0.5) {
    styles.push('Acróbata de letras');
  }

  // Score
  if (metrics.averageWordScore > 25) {
    styles.push('Pegador pesado');
  }

  // Return max 3
  return styles.slice(0, 3);
}
